// extracted by mini-css-extract-plugin
var _1 = "ra-art-details";
var _2 = "ra-art-details-item";
var _3 = "ra-art-details-label";
var _4 = "ra-art-details-list-item";
export { _1 as "artDetailsCls", _2 as "artDetailsItemCls", _3 as "artDetailsLabelCls", _4 as "artDetailsListItemCls" }
